// src/store/action.js
// eslint-disable-next-line import/no-cycle
import { login, register, logout, getCurrentUser, sendEmailCode, sendForgotPasswordCode, resetPassword } from '@/api/auth'
import * as types from './mutation-type'

export default {
  // 原有actions...

  // 登錄
  async login({ commit }, userInfo) {
    try {
      commit(types.SET_LOGIN_LOADING, true)
      const response = await login(userInfo)

      if (response.code === 200) {
        const { token, user } = response.data

        commit(types.SET_TOKEN, token)
        commit(types.SET_USER, user)
        commit(types.SET_LOGGED_IN, true)

        return response
      }
      throw new Error(response.message || '登錄失敗')
    } catch (error) {
      console.error('登錄失敗:', error)
      throw error
    } finally {
      commit(types.SET_LOGIN_LOADING, false)
    }
  },

  // 註冊
  async register({ commit }, userInfo) {
    try {
      commit(types.SET_REGISTER_LOADING, true)
      const response = await register(userInfo)

      if (response.code === 200) {
        return response
      }
      throw new Error(response.message || '註冊失敗')
    } catch (error) {
      console.error('註冊失敗:', error)
      throw error
    } finally {
      commit(types.SET_REGISTER_LOADING, false)
    }
  },

  // 發送郵箱驗證碼
  async sendEmailCode({ commit }, email) {
    try {
      const response = await sendEmailCode(email)
      if (response.code === 200) {
        return response
      } else {
        throw new Error(response.message || '發送驗證碼失敗')
      }
    } catch (error) {
      console.error('發送驗證碼失敗:', error)
      throw error
    }
  },

  // 發送重置密碼郵箱驗證碼
  async sendForgotPasswordCode({ commit }, email) {
    try {
      const response = await sendForgotPasswordCode(email)
      if (response.code === 200) {
        return response
      } else {
        throw new Error(response.message || '發送驗證碼失敗')
      }
    } catch (error) {
      console.error('發送驗證碼失敗:', error)
      throw error
    }
  },

  // 重置密碼
  async resetPassword({ commit }, data) {
    try {
      const response = await resetPassword(data);
      if (response.code === 200) {
        return response
      } else {
        throw new Error(response.message || '重置密碼失敗')
      }
    } catch (error) {
      throw error;
    }
  },

  // 退出登錄
  async logout({ commit }) {
    try {
      await logout()
    } catch (error) {
      console.error('退出登錄失敗:', error)
    } finally {
      commit(types.CLEAR_USER)
    }
  },

  // 檢查登錄狀態
  async checkAuth({ commit, state }) {
    if (!state.token) {
      commit(types.SET_LOGGED_IN, false)
      return false
    }

    try {
      const response = await getCurrentUser()
      if (response.code === 200) {
        commit(types.SET_USER, response.data)
        commit(types.SET_LOGGED_IN, true)
        return true
      }
      commit(types.CLEAR_USER)
      return false
    } catch (error) {
      commit(types.CLEAR_USER)
      return false
    }
  },
}
